import { isNullOrUndefined } from 'utils/object-utils';

export const chatBotFailApiResponse =
  ' I am sorry, but I am unable to establish connection and process the request currently. Please try again after sometime.';
export const MAX_RETRY_COUNT = 3;
export const goodResponseDefaultState = {
  completeness: false,
  accuracy: false,
  understandability: false,
  other: false,
};

export const badResponseDefaultState = {
  completeness: false,
  accuracy: false,
  understandability: false,
  incorrect_topic: false,
  incorrect_sources: false,
  inappropriate: false,
  other: false,
};

export const DOC_INDEXING_STATUS = {
  NOT_STARTED: 0,
  IN_PROGRESS: 1,
  COMPLETED: 2,
  FAILED: 3,
  COMPLETED_WITH_ERROR: 4,
  PURGED: 5,
};

export const PROCESS_TYPES = {
  INDEXING: 'INDEXING',
  SUMMARY_GENERATION: 'SUMMARY_GENERATION',
};

export const CHAT_BOT_TYPING_ID = 'typing';
export const THUMBS_UP = 'thumbs_up';
export const THUMBS_DOWN = 'thumbs_down';

export const getInitials = (string) => {
  if (isNullOrUndefined(string)) return;
  const initials = string.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);
  return initials[0] + initials[1];
};

export const goodReasonCheckboxOptions = [
  {
    id: 'completeness',
    label: 'chatbot.response.type.good.completeness',
    value: 'completeness',
  },
  {
    id: 'accuracy',
    label: 'chatbot.response.type.good.accuracy',
    value: 'accuracy',
  },
  {
    id: 'understandability',
    label: 'chatbot.response.type.good.understandability',
    value: 'understandability',
  },
  {
    id: 'other',
    label: 'chatbot.response.type.good.other',
    value: 'other',
  },
];

export const badReasonCheckboxOptions = [
  {
    id: 'completeness',
    label: 'chatbot.response.type.bad.completeness',
    value: 'completeness',
  },
  {
    id: 'accuracy',
    label: 'chatbot.response.type.bad.accuracy',
    value: 'accuracy',
  },
  {
    id: 'understandability',
    label: 'chatbot.response.type.bad.understandability',
    value: 'understandability',
  },
  {
    id: 'incorrect_topic',
    label: 'chatbot.response.type.bad.incorrect.topic',
    value: 'incorrect_topic',
  },
  {
    id: 'incorrect_sources',
    label: 'chatbot.response.type.bad.incorrect.sources',
    value: 'incorrect_sources',
  },
  {
    id: 'inappropriate',
    label: 'chatbot.response.type.bad.inappropriate',
    value: 'inappropriate',
  },
  {
    id: 'other',
    label: 'chatbot.response.type.bad.other',
    value: 'other',
  },
];

export const groupCitation = (message) => {
  let citations = [];

  message.documentSource &&
    message.documentSource.forEach((doc) => {
      let pageNumber = doc.page_number;
      let citation = doc.citation_string.replace(/\n+/g, ' ');

      const pageRefMatch = citation.match(/^\[(\d+)\]:\s*/);
      let pageRef = null;
      let citationText = citation;

      if (pageRefMatch) {
        pageRef = pageRefMatch[1]; 
        citationText = citation.slice(pageRefMatch[0].length); 
      }

      // Format the citation string
      let formattedCitation =
        citationText.length > 40
          ? citationText.slice(0, 20) + '[....]' + citationText.slice(-20)
          : citationText;

      citations.push({
        pageNumber,
        pageRef,
        citationText: formattedCitation,
      });
    });

  return citations;
};

export const createPreviousMessages = (messages) => {
  if (messages.length <= 1) {
    return [];
  }

  let groupedArray = [];

  for (let i = 0; i < messages.length; i += 2) {
    if (i + 1 < messages.length) {
      let groupedObject = {
        timestamp: messages[i + 1].timestamp,
        message: messages[i].message,
        response: messages[i + 1].response,
      };
      groupedArray.push(groupedObject);
    }
  }

  return groupedArray.length > 3 ? groupedArray.slice(-3) : groupedArray;
};
